import { Divider, message } from "antd";
import PForm from "./components/PForm/PForm";
import { useState } from "react";
import Login from "./components/Login/Login";

const App = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = (status) => {
    setIsLoggedIn(status);
  };

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // minHeight: "800px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#eee",
        }}
      >
        {contextHolder}
        {isLoggedIn ? (
          <div
            style={{
              width: "90%",
              height: "100%",
              margin: "50px 0",
              borderRadius: "10px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            }}
          >
            <div
              style={{
                height: "calc(100% - 90px)",
                padding: "20px",
                overflow: "auto",
                backgroundColor: "#fff",
              }}
            >
              <h3 style={{ margin: "0" }}>TurboLader.de Ebay Code Generator</h3>
              <Divider />
              <PForm messageApi={messageApi}></PForm>
            </div>

            <div
              style={{
                height: "50px",
                textAlign: "center",
                backgroundColor: "#f1f1f1",
                borderRadius: "0 0 10px 10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                Powered by{" "}
                <a
                  href="https://abnjunction.com/"
                  style={{ color: "#1677ff", textDecorationLine: "none" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  ABNJunction@2025
                </a>
              </div>
            </div>
          </div>
        ) : (
          <Login onLogin={handleLogin} />
        )}
      </div>
    </>
  );
};

export default App;
